// extracted by mini-css-extract-plugin
module.exports = {"paper":"Rules_paper__PjwCy","rulesHolder":"Rules_rulesHolder___Nf7f"};